// extracted by mini-css-extract-plugin
export default {"btn":"AddTodo_btn__nvR7V","input":"AddTodo_input__OSd7f","list":"AddTodo_list__oydZQ"};